/**
 * Utility functions for role-based access control
 * Roles: ADMIN (full access), USER (standard access)
 */

/**
 * Check if user has admin privileges
 */
export const isAdmin = (user) => {
  return user?.role === "ADMIN";
};

/**
 * Check if user has specific role
 */
export const hasRole = (user, role) => {
  return user?.role === role;
};

/**
 * Check if user has any of the specified roles
 */
export const hasAnyRole = (user, roles) => {
  return roles.includes(user?.role);
};

/**
 * User role constants
 */
export const USER_ROLES = {
  ADMIN: "ADMIN",
  USER: "USER",
};
